import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿SAINT® es ambulatoria?",
    answer:
      "Sí. SAINT® se administra en un entorno ambulatorio, con el paciente despierto y sin anestesia. La mayoría de los pacientes que viven fuera del área se quedan localmente durante la semana de cinco días.",
  },
];

export const esOutpatientSaint = makeEsArticle({
  slug: "outpatient-saint-tms",
  title: "SAINT® TMS ambulatoria: cómo funciona",
  description:
    "SAINT® es un tratamiento ambulatorio sin anestesia. Para pacientes que viajan, la semana de cinco días hace que alojarse localmente sea práctico.",
  h1: "SAINT® TMS ambulatoria",
  breadcrumbLabel: "SAINT® ambulatoria",
  shortAnswer:
    "SAINT® es un tratamiento ambulatorio: el paciente permanece despierto, sin anestesia ni sedación, en un entorno ambulatorio con suites de tratamiento privadas. Como toda la semana se completa en cinco días consecutivos, muchos pacientes que viajan desde fuera del área se alojan localmente durante esa semana en lugar de desplazarse varias semanas como exige la TMS convencional.",
  keyTakeaways: [
    "SAINT® es ambulatoria, sin anestesia.",
    "El paciente permanece despierto.",
    "La semana se completa en cinco días consecutivos.",
    "Muchos pacientes que viajan se alojan localmente una semana.",
    "La TMS convencional exige desplazamientos durante varias semanas.",
  ],
  sections: [
    {
      heading: "Por qué es ambulatoria",
      paragraphs: [
        "SAINT® utiliza estimulación magnética, no estimulación eléctrica, y no requiere anestesia ni sedación. El paciente permanece despierto y alerta y puede generalmente conducir al y desde la clínica cada día.",
      ],
    },
    {
      heading: "Para pacientes que viajan",
      paragraphs: [
        "Como toda la semana se completa en cinco días consecutivos, muchos pacientes que viajan desde fuera del área se alojan localmente durante una semana en lugar de desplazarse durante seis semanas como exige la TMS convencional. [[Consulte nuestra guía de viaje|/es/saint-tms-travel]] para planificar su visita.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
